import { useState } from 'react';
import { useForm } from 'react-hook-form';
import CustomizedSnackbars from '../../Notifications/SnackBar';
import ModalBase from '../../Controls/ModalBase';
import { Box, Button, FormControl, Grid, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Delete, HighlightOff } from '@mui/icons-material';
import { anularDenuncia } from '../helpers/denunciaService';

export const AnularDenunciaModal = (props) => {
  const { denuncia, setDenunciaAnulada } = props;
  const [message, setMessage] = useState({ open: false, message: null, severity: 'success' });
  const [loadingAnular, setLoadingAnular] = useState(false);

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur', defaultValues: { id: denuncia?.id, observacion: null } });

  const onAnularAutorizacion = async (data, event) => {
    event.preventDefault();
    setLoadingAnular(true);
    try {
      setLoadingAnular(true);
      const res = await anularDenuncia(data);
      if (res) {
        setMessage({
          open: true,
          message: 'El reclamo ha sido anulado correctamente',
          severity: 'success',
        });
        setDenunciaAnulada(true);
      }
    } catch (e) {
      setMessage({ open: true, message: 'Error al anular el reclamo', severity: 'error' });
    } finally {
      setLoadingAnular(false);
    }
  };

  const handleClose = () => {
    setLoadingAnular(false);
    setDenunciaAnulada(false);
    reset();
  };

  const handleBorrarMensaje = () => {
    setMessage({ open: false, message: null, severity: 'success' });
  };

  const DrawerForm = (
    <form onSubmit={handleSubmit(onAnularAutorizacion)}>
      <FormControl fullWidth={true} variant='outlined' margin='normal'>
        <TextField
          multiline
          maxRows={4}
          {...register('observacion', {
            required: {
              value: true,
              message: 'El campo es requerido',
            },
            maxLength: {
              value: 500,
              message: 'El campo es demasiado largo',
            },
          })}
          variant='standard'
          fullWidth
          name='observacion'
          label='Ingresá la observación'
          error={!!errors.observacion}
          helperText={errors.observacion ? errors.observacion.message : ''}
        />
      </FormControl>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          gap: 2,
          flexWrap: { xs: 'wrap', sm: 'nowrap' },
          mt: 4,
          mb: 1,
        }}
      >
        <Button
          variant='contained'
          startIcon={<HighlightOff />}
          color='neutral'
          onClick={handleClose}
          fullWidth
          sx={{ order: { xs: 1, sm: 0 } }}
        >
          Cancelar
        </Button>
        <LoadingButton
          fullWidth
          variant='contained'
          size='medium'
          color='primary'
          startIcon={<Delete />}
          type='submit'
          loading={loadingAnular}
          sx={{ order: { xs: 0, sm: 1 } }}
        >
          Anular
        </LoadingButton>
      </Box>
    </form>
  );

  const popUpAnular = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography gutterBottom variant='h6'>
          ¿Estás seguro que deseas anular el reclamo?
        </Typography>
        {DrawerForm}
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <ModalBase
        fullWidth={false}
        open={true}
        content={popUpAnular}
        title='Anular Reclamo'
        setDenunciaAnulada={setDenunciaAnulada}
      />
      {message.message && (
        <CustomizedSnackbars
          open={message?.open || false}
          autoHideDuration={8000}
          severity={message.severity}
          message={message.message}
          onDeleteMessage={handleBorrarMensaje}
        />
      )}
    </Box>
  );
};
